import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import CategoryIcon from "@material-ui/icons/Category";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import GavelIcon from "@material-ui/icons/Gavel";
import MoneyIcon from "@material-ui/icons/Money";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { showSidebar } from "../../../redux/actions/sidebarActions";
import { checkRequiredPermissions, USER_GROUPS } from "../../../Utils/Common";
import CollapseGroup from "../CollapseGroup";

/**
 * Manufacturing module entry with sub navigation for recipes, feature lists, and serialised sub-assemblies.
 */
export default function ManufacturingModule() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const serialisedSubAssembliesLabel = t(
    "manufacturing.serialisedSubAssemblies",
    "Serialised sub-assemblies"
  );

  return checkRequiredPermissions([
    USER_GROUPS.ADMIN,
    USER_GROUPS.PRODUCTION,
  ]) ? (
    <CollapseGroup
      mainItemAction={() => {
        history.push("/cpanel/manufacturing");
        dispatch(showSidebar(false));
      }}
      mainItemIcon={<GavelIcon />}
      header={t("manufacturing.header")}
    >
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/manufacturing/recipes");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <FormatListBulletedIcon />
        </ListItemIcon>
        <ListItemText primary={t("manufacturing.recipes")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/manufacturing/features");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <CategoryIcon />
        </ListItemIcon>
        <ListItemText primary={t("manufacturing.featureLists")} />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push("/cpanel/manufacturing/serialisedsubassemblies");
          dispatch(showSidebar(false));
        }}
      >
        <ListItemIcon>
          <MoneyIcon />
        </ListItemIcon>
        <ListItemText
          primary={serialisedSubAssembliesLabel}
          primaryTypographyProps={{
            style: {
              fontSize:
                serialisedSubAssembliesLabel.length > 15 ? 13 : undefined,
            },
          }}
        />
      </ListItem>
    </CollapseGroup>
  ) : null;
}
